export default function(path, route) {
	let location;
	let currentPath;
	let isMatch = false;

	if (route && route.fullPath) {
		//then we're on a vue-ui route
		location = route.fullPath;
	} else {
		location = window.location.pathname;
	}

	currentPath = location + window.location.search;

	isMatch = currentPath.includes(path);

	return isMatch;
}
